<section class="identity-consent" [attr.aria-label]="panelAriaLabel()">
  <h2 class="identity-consent__title">
    {{ titleKey() | translate }}
  </h2>
  <p class="identity-consent__body">
    {{ bodyKey() | translate }}
  </p>

  <section class="identity-consent__panel" [attr.aria-label]="panelAriaLabel()">
    <div class="identity-consent__lead">
      <img [src]="leadIconSrc()" alt="" width="18" height="18" aria-hidden="true" />
      <span>{{ leadLabelKey() | translate }}</span>
    </div>

    <ul class="identity-consent__list">
      @for (pointKey of pointKeys(); track pointKey) {
        <li>{{ pointKey | translate }}</li>
      }
    </ul>

    <div class="identity-consent__note" role="note">
      {{ noteKey() | translate }}
    </div>
  </section>

  <label class="identity-consent__checkbox">
    <input
      type="checkbox"
      [checked]="checked()"
      (change)="checked.set($any($event.target).checked)"
    />
    <span>{{ checkboxLabelKey() | translate }}</span>
  </label>

  <div class="identity-consent__actions">
    <app-parent-button variant="ghost" (clicked)="back.emit()">
      {{ backLabelKey() | translate }}
    </app-parent-button>
    <app-parent-button
      variant="primary"
      [disabled]="!checked() || busy()"
      [loading]="busy()"
      (clicked)="continue.emit()"
    >
      {{ continueLabelKey() | translate }}
    </app-parent-button>
  </div>
</section>
